import styled, { css } from 'styled-components';

// Styles
import { hoverCapable } from '../../../../../../styles/hover';

// Styled Components
import { Container, Tr } from '../../../summaryTables/SummaryTablesStyles';
import { TextCell } from '../../../components/MainStyledComponents';

// Components
import { InputRadio } from '../../../../../inputs/InputRadio';

// Types

// Esta pantalla tiene UNA sola tabla, así que se alinea con el patrón de
// TeamsManagementTable (columna a ancho completo) en vez del de dos tablas
// enfrentadas. Antes heredaba el `display:flex` en fila con `gap: 9.8rem` y un
// `max-width: 92rem` en el contenedor de la tabla, restos de la pantalla de
// Vehículos (activos/inactivos), donde sí hay dos.
//
// El efecto era que la tabla vivía en 920 px dentro de una tarjeta mucho más
// ancha: con 7 columnas medía 2.421 px y había que arrastrar ~1.500 px a la
// derecha para llegar a «Equipos» —la columna que añadió la entrega de
// materiales por equipo— mientras sobraban ~900 px vacíos a su derecha.
export const ContainerTable = styled(Container)`
  display: flex;
  flex-direction: column;
  gap: 2.8rem;
  width: 100%;
`;

export const MaterialsTableContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 2.8rem;
  width: 100%;
`;

/**
 * Lista de INACTIVOS. Mismas medidas que la de activos a propósito: las dos
 * pintan la misma tabla y una más estrecha se lee como si le faltaran columnas.
 *
 * 🔴 El `max-width: 92rem` que traía el estilo muerto del que se recicla se
 * retira: dejaba la segunda lista visiblemente más corta que la primera.
 */
export const InactiveMaterialsTableContainer = styled(MaterialsTableContainer)``;

export const FiltersContainer = styled.div`
  display: flex;
  align-items: end;
  gap: ${({ theme }) => theme.spaces.m}rem;
  div:last-child {
    flex: 1;
  }
`;

export const TrStyled = styled(Tr)`
  background-color: ${(props) => props.checked && props.theme.colors.paleGrey};
  ${({ indeterminate, checked }) => css`
    Td {
      ${!indeterminate && {
        opacity: 0.2,
      }}
      ${checked && {
        opacity: 1,
      }}
    }
  `}
`;

export const InputRadioStyled = styled(InputRadio)``;

// Las celdas de estas tablas van con `white-space: nowrap`, y los materiales
// tienen nombres larguísimos ("Càmera de TV compacte digital color amb sensor
// CCD D1/3 (752 x 528 Punst actius) 625 línees"). Una sola fila así estiraba la
// columna «Material» a 1.314 px y empujaba «Equipos» fuera de la pantalla.
//
// Se reutiliza `TextCell` (la celda con puntos suspensivos que ya usan las
// tablas grandes) y sólo se le pone el tope de ancho. El texto completo no se
// pierde: va en el `title`, que el navegador enseña al pasar por encima.
export const MaterialNameCell = styled(TextCell)`
  display: block;
  max-width: 40rem;
`;

export const SubCodificationCell = styled(TextCell)`
  display: block;
  max-width: 26rem;
`;

// Materiales por equipo (2026-07-31) — mismos estilos que TeamsManagementTable
// para que las dos tablas de Gestión se lean igual.
export const TagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  max-width: 20rem;
`;

export const Tag = styled.span`
  background-color: ${({ theme }) => theme.colors.paleGrey};
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 1rem;
  white-space: nowrap;
`;

export const ActionCell = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ActionButton = styled.button`
  font-size: 2rem;
  color: ${({ theme }) => theme.colors.white};
  min-height: 4rem;
  min-width: 4rem;
  border: none;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.colors.garnet};
  cursor: pointer;

  /* Solo con puntero fino: en táctil el :hover se queda pegado tras
     el toque (ver styles/hover.ts). */
  ${hoverCapable} {
    &:hover {
      opacity: 0.9;
    }
  }
`;

/**
 * Flecha de intercambio entre las dos listas del catálogo.
 *
 * Estos tres estilos existían ya en este fichero como **código muerto**
 * (`SwapVehicle*`, herencia de una copia: `VehiclesManagementTable` importa los
 * suyos de su propio `./styles`). Se reciclan renombrados en vez de añadir unos
 * nuevos al lado.
 */
export const SwapMaterialButton = styled.button`
  font-size: 2rem;
  color: ${({ theme }) => theme.colors.white};
  min-height: 4rem;
  min-width: 4rem;
  width: 4rem;
  border: none;
  border-radius: 5px;
  background-color: ${({ theme }) =>
    theme.colors.garnet}; /* CAMBIO: Color principal ROIS */
`;

export const SwapMaterialButtonRight = styled(SwapMaterialButton)`
  align-self: end;
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
    align-self: flex-start;
  }
`;
